import {ScriptureSelection} from "@/models/ScriptureSelectionModel";
import {AppInstance} from "@/models/AppInstanceModel";
import {EMPTY_GUID} from "@/utils/GuidUtil";

function hasAudioLibraryId(id?: string | null): boolean {
    return !!id && id !== EMPTY_GUID;
}

export interface Journey {
    id: string;
    title: string;
    storyContent: string;
    scriptureAudio: string;
    scriptureAudioFilename: string;
    scriptureAudioId?: string;
    scriptureAudioSizeKb?: number | null;
    extraContent: string;
    extraAudio: string;
    extraAudioFilename: string;
    extraAudioId?: string;
    extraAudioSizeKb?: number | null;
    displayOrder: number;
    journeySetId: string;
    scriptureSelections: ScriptureSelection[];
    videoLabel: string;
    videoUrl: string;
    extraVideoUrl: string;
    extraVideoLabel: string;
    introTabTopText: string;
    introTabBottomText: string;
    introTabTopAudio: string;
    introTabTopAudioFilename: string;
    introTabTopAudioId?: string;
    introTabTopAudioSizeKb?: number | null;
    introTabBottomAudio: string;
    introTabBottomAudioFilename: string;
    introTabBottomAudioId?: string;
    introTabBottomAudioSizeKb?: number | null;
    introTabScriptureAudio: string;
    introTabScriptureAudioFilename: string;
    introTabScriptureAudioId?: string;
    introTabScriptureAudioSizeKb?: number | null;
    introTabVideoUrl: string;
    introTabVideoLabel: string;
    scriptureTabTopContent: string;
    scriptureTabTopAudio: string;
    scriptureTabTopAudioFilename: string;
    scriptureTabTopAudioId?: string;
    scriptureTabTopAudioSizeKb?: number | null;
    scriptureTabStoryAudio: string;
    scriptureTabStoryAudioFilename: string;
    scriptureTabStoryAudioId?: string;
    scriptureTabStoryAudioSizeKb?: number | null;
    extraTabTopContent: string;
    extraTabTopAudio: string;
    extraTabTopAudioFilename: string;
    extraTabTopAudioId?: string;
    extraTabTopAudioSizeKb?: number | null;
    extraTabScriptureAudio: string;
    extraTabScriptureAudioFilename: string;
    extraTabScriptureAudioId?: string;
    extraTabScriptureAudioSizeKb?: number | null;
    extraTabBottomAudio: string;
    extraTabBottomAudioFilename: string;
    extraTabBottomAudioId?: string;
    extraTabBottomAudioSizeKb?: number | null;
    finalTabTopText: string;
    finalTabBottomText: string;
    finalTabVideoUrl: string;
    finalTabVideoLabel: string;
    finalTabTopAudio: string;
    finalTabTopAudioFilename: string;
    finalTabTopAudioId?: string;
    finalTabTopAudioSizeKb?: number | null;
    finalTabBottomAudio: string;
    finalTabBottomAudioFilename: string;
    finalTabBottomAudioId?: string;
    finalTabBottomAudioSizeKb?: number | null;
    finalTabScriptureAudio: string;
    finalTabScriptureAudioFilename: string;
    finalTabScriptureAudioId?: string;
    finalTabScriptureAudioSizeKb?: number | null;
    introTabResourceListHeading: string;
    scriptureTabResourceListHeading: string;
    extraTabResourceListHeading: string;
    finalTabResourceListHeading: string;
}

export function validateJourney(journey: Journey): Journey {
    journey.scriptureAudio = (journey.scriptureAudio) ? journey.scriptureAudio : '';
    journey.scriptureAudioFilename = (journey.scriptureAudioFilename) ? journey.scriptureAudioFilename : '';
    journey.extraContent = (journey.extraContent) ? journey.extraContent : '';
    journey.extraAudio = (journey.extraAudio) ? journey.extraAudio : '';
    journey.extraAudioFilename = (journey.extraAudioFilename) ? journey.extraAudioFilename : '';
    journey.journeySetId = (journey.journeySetId) ? journey.journeySetId : '';
    journey.scriptureSelections = (journey.scriptureSelections) ? journey.scriptureSelections : [];
    journey.videoLabel = (journey.videoLabel) ? journey.videoLabel : '';
    journey.videoUrl = (journey.videoUrl) ? journey.videoUrl : '';
    journey.extraVideoUrl = (journey.extraVideoUrl) ? journey.extraVideoUrl : '';
    journey.extraVideoLabel = (journey.extraVideoLabel) ? journey.extraVideoLabel : '';
    journey.introTabTopText = (journey.introTabTopText) ? journey.introTabTopText : '';
    journey.introTabBottomText = (journey.introTabBottomText) ? journey.introTabBottomText : '';
    journey.introTabTopAudio = (journey.introTabTopAudio) ? journey.introTabTopAudio : '';
    journey.introTabTopAudioFilename = (journey.introTabTopAudioFilename) ? journey.introTabTopAudioFilename : '';
    journey.introTabBottomAudio = (journey.introTabBottomAudio) ? journey.introTabBottomAudio : '';
    journey.introTabBottomAudioFilename = (journey.introTabBottomAudioFilename) ? journey.introTabBottomAudioFilename : '';
    journey.introTabScriptureAudio = (journey.introTabScriptureAudio) ? journey.introTabScriptureAudio : '';
    journey.introTabScriptureAudioFilename = (journey.introTabScriptureAudioFilename) ? journey.introTabScriptureAudioFilename : '';
    journey.introTabVideoUrl = (journey.introTabVideoUrl) ? journey.introTabVideoUrl : '';
    journey.introTabVideoLabel = (journey.introTabVideoLabel) ? journey.introTabVideoLabel : '';
    journey.scriptureTabTopContent = (journey.scriptureTabTopContent) ? journey.scriptureTabTopContent : '';
    journey.scriptureTabTopAudio = (journey.scriptureTabTopAudio) ? journey.scriptureTabTopAudio : '';
    journey.scriptureTabTopAudioFilename = (journey.scriptureTabTopAudioFilename) ? journey.scriptureTabTopAudioFilename : '';
    journey.scriptureTabStoryAudio = (journey.scriptureTabStoryAudio) ? journey.scriptureTabStoryAudio : '';
    journey.scriptureTabStoryAudioFilename = (journey.scriptureTabStoryAudioFilename) ? journey.scriptureTabStoryAudioFilename : '';
    journey.extraTabTopContent = (journey.extraTabTopContent) ? journey.extraTabTopContent : '';
    journey.extraTabTopAudio = (journey.extraTabTopAudio) ? journey.extraTabTopAudio : '';
    journey.extraTabTopAudioFilename = (journey.extraTabTopAudioFilename) ? journey.extraTabTopAudioFilename : '';
    journey.extraTabScriptureAudio = (journey.extraTabScriptureAudio) ? journey.extraTabScriptureAudio : '';
    journey.extraTabScriptureAudioFilename = (journey.extraTabScriptureAudioFilename) ? journey.extraTabScriptureAudioFilename : '';
    journey.extraTabBottomAudio = (journey.extraTabBottomAudio) ? journey.extraTabBottomAudio : '';
    journey.extraTabBottomAudioFilename = (journey.extraTabBottomAudioFilename) ? journey.extraTabBottomAudioFilename : '';
    journey.finalTabTopText = (journey.finalTabTopText) ? journey.finalTabTopText : '';
    journey.finalTabBottomText = (journey.finalTabBottomText) ? journey.finalTabBottomText : '';
    journey.finalTabVideoUrl = (journey.finalTabVideoUrl) ? journey.finalTabVideoUrl : '';
    journey.finalTabVideoLabel = (journey.finalTabVideoLabel) ? journey.finalTabVideoLabel : '';
    journey.finalTabTopAudio = (journey.finalTabTopAudio) ? journey.finalTabTopAudio : '';
    journey.finalTabTopAudioFilename = (journey.finalTabTopAudioFilename) ? journey.finalTabTopAudioFilename : '';
    journey.finalTabBottomAudio = (journey.finalTabBottomAudio) ? journey.finalTabBottomAudio : '';
    journey.finalTabBottomAudioFilename = (journey.finalTabBottomAudioFilename) ? journey.finalTabBottomAudioFilename : '';
    journey.finalTabScriptureAudio = (journey.finalTabScriptureAudio) ? journey.finalTabScriptureAudio : '';
    journey.introTabResourceListHeading = (journey.introTabResourceListHeading) ? journey.introTabResourceListHeading : '';
    journey.scriptureTabResourceListHeading = (journey.scriptureTabResourceListHeading) ? journey.scriptureTabResourceListHeading : '';
    journey.extraTabResourceListHeading = (journey.extraTabResourceListHeading) ? journey.extraTabResourceListHeading : '';
    journey.finalTabResourceListHeading = (journey.finalTabResourceListHeading) ? journey.finalTabResourceListHeading : '';
    return journey;
}

/** When a library audio id is set, drop inline base64 for that slot so PUT does not send stale blobs. Call before clearLegacyAudioWhenCleared / updateJourney. */
export function clearLegacyInlineAudioWhenLibraryIdSet(journey: Journey): void {
    const j = journey as unknown as Record<string, string>;
    if (hasAudioLibraryId(journey.introTabTopAudioId)) j.introTabTopAudio = '';
    if (hasAudioLibraryId(journey.introTabBottomAudioId)) j.introTabBottomAudio = '';
    if (hasAudioLibraryId(journey.introTabScriptureAudioId)) j.introTabScriptureAudio = '';
    if (hasAudioLibraryId(journey.scriptureTabTopAudioId)) j.scriptureTabTopAudio = '';
    if (hasAudioLibraryId(journey.scriptureAudioId)) j.scriptureAudio = '';
    if (hasAudioLibraryId(journey.scriptureTabStoryAudioId)) j.scriptureTabStoryAudio = '';
    if (hasAudioLibraryId(journey.extraTabTopAudioId)) j.extraTabTopAudio = '';
    if (hasAudioLibraryId(journey.extraTabBottomAudioId)) j.extraTabBottomAudio = '';
    if (hasAudioLibraryId(journey.extraTabScriptureAudioId)) j.extraTabScriptureAudio = '';
    if (hasAudioLibraryId(journey.extraAudioId)) j.extraAudio = '';
    if (hasAudioLibraryId(journey.finalTabTopAudioId)) j.finalTabTopAudio = '';
    if (hasAudioLibraryId(journey.finalTabBottomAudioId)) j.finalTabBottomAudio = '';
    if (hasAudioLibraryId(journey.finalTabScriptureAudioId)) j.finalTabScriptureAudio = '';
}

/** Clear legacy audio blob fields when the user has cleared the picker (no id and no filename). Call before updateJourney so the backend receives empty blob. */
export function clearLegacyAudioWhenCleared(journey: Journey): void {
    const clearIfEmpty = (id: string | undefined, filename: string | undefined, blobRef: keyof Journey) => {
        if (!id && !filename) (journey as unknown as Record<string, string>)[blobRef] = '';
    };
    clearIfEmpty(journey.introTabTopAudioId, journey.introTabTopAudioFilename, 'introTabTopAudio');
    clearIfEmpty(journey.introTabBottomAudioId, journey.introTabBottomAudioFilename, 'introTabBottomAudio');
    clearIfEmpty(journey.introTabScriptureAudioId, journey.introTabScriptureAudioFilename, 'introTabScriptureAudio');
    clearIfEmpty(journey.scriptureTabTopAudioId, journey.scriptureTabTopAudioFilename, 'scriptureTabTopAudio');
    clearIfEmpty(journey.scriptureAudioId, journey.scriptureAudioFilename, 'scriptureAudio');
    clearIfEmpty(journey.scriptureTabStoryAudioId, journey.scriptureTabStoryAudioFilename, 'scriptureTabStoryAudio');
    clearIfEmpty(journey.extraTabTopAudioId, journey.extraTabTopAudioFilename, 'extraTabTopAudio');
    clearIfEmpty(journey.extraTabBottomAudioId, journey.extraTabBottomAudioFilename, 'extraTabBottomAudio');
    clearIfEmpty(journey.extraTabScriptureAudioId, journey.extraTabScriptureAudioFilename, 'extraTabScriptureAudio');
    clearIfEmpty(journey.extraAudioId, journey.extraAudioFilename, 'extraAudio');
    clearIfEmpty(journey.finalTabTopAudioId, journey.finalTabTopAudioFilename, 'finalTabTopAudio');
    clearIfEmpty(journey.finalTabBottomAudioId, journey.finalTabBottomAudioFilename, 'finalTabBottomAudio');
    clearIfEmpty(journey.finalTabScriptureAudioId, journey.finalTabScriptureAudioFilename, 'finalTabScriptureAudio');
}

export function getMissingJourneyInfo(journey: Journey, needsExtraInfo: boolean, appInstance: AppInstance, language: any): string {
    let message = '';
    if (!journey.title.trim()) {
        message += `<li>${ language.journeyTitle }</li>`;
    }
/*     if (appInstance.allowStorytelling && !journey.storyContent?.trim()) {
        message += `<li>${ language.journeyStoryContent }</li>`;
    } */
    if (!journey.scriptureSelections || journey.scriptureSelections.length === 0) {
        message += `<li>${ language.journeyScriptureSelections }</li>`;
    }
    if (!journey.scriptureAudio?.trim() && !journey.scriptureAudioId) {
        message += `<li>${ language.journeyScriptureAudio }</li>`;
    }
    if (needsExtraInfo && !journey.extraContent?.trim()) {
        message += `<li>${ language.journeyAddtlTabContent }</li>`;
    }
    if (needsExtraInfo && !journey.extraAudio?.trim() && !journey.extraAudioId) {
        message += `<li>${ language.journeyAddtlTabAudio }</li>`;
    }
    return message;
}